<div class="globalComponent" id="scrollTop" [style.maxHeight]="isModal ? '80vh' : ''">
  <div class="buttons-bar" *ngIf="data?.patientId">
    <button mat-icon-button color="warn" class="negative-margin" mat-dialog-close matTooltip="{{ 'btn.close' | translate }}">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h2>{{ i18n.title | translate }}</h2>

  <div class="defListContainer">
    <div class="loading" *ngIf="!pageLoaded">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
    </div>

    <div *ngIf="pageLoaded">
      <div class="paramsEditor editToggle" *ngIf="canUpdateParamFreq && paramsToUpdate">
        <div style="float: right">
          <button mat-icon-button color="primary" (click)="saveParamsFreq()" matTooltip="{{ 'common.save' | translate }}">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-icon-button class="negative-margin" matTooltip="{{ 'btn.close' | translate }}" (click)="paramsToUpdate = null">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <h2>{{ paramsToUpdate.translatedName }}</h2>
        <form [formGroup]="paramForm">
          <mat-slide-toggle formControlName="allowUserEdit">
            <span [ngStyle]="{ color: paramForm.controls.allowUserEdit.value ? 'red' : 'gray' }">
              {{ "mydrugs.allowUserEdit" | translate }}
            </span>
          </mat-slide-toggle>
        </form>

        <ng-container *ngFor="let freq of frequenciesToUpdate; let i = index">
          <div [ngClass]="{ 'multiple-frequencies': frequenciesToUpdate.length > 1 }">
            <app-timing-editor
              [mode]="1"
              [isFrequencyDisplayed]="true"
              [(frequency)]="frequenciesToUpdate[i]"
              [isMomentRequired]="true"
              [largeDisplay]="false"
              [hasCycle]="false"
              [needStartEnd]="true"
              [disableStartEnd]="paramsToUpdate.limitedCreationByFrequence"
              [disableDuration]="paramsToUpdate.limitedCreationByFrequence"
              [needQuantities]="false"
              [needYear]="true"
              [needDuration]="true"
              [needEmptyInterval]="true"
              [needAsNecessary]="false"
              [constraints]="paramsToUpdate.constraints"
            ></app-timing-editor>
            <button
              *ngIf="frequenciesToUpdate.length > 1 && !paramsToUpdate.limitedCreationByFrequence"
              mat-stroked-button
              type="button"
              color="warn"
              style="margin-top: 5px; width: 100%"
              (click)="removeFrequency(i)"
            >
              {{ "common.delete" | translate }}
            </button>
            <hr />
          </div>
        </ng-container>

        <button
          *ngIf="!paramsToUpdate.limitedCreationByFrequence && frequenciesToUpdate"
          mat-raised-button
          type="button"
          color="primary"
          style="width: 100%; margin: 10px"
          (click)="addFrequency()"
        >
          {{ "page.questionnaireEditor.properties.addFrequency" | translate }}
        </button>
      </div>

      <h3>{{ i18n.careplanSection | translate }} :</h3>
      <div class="container">
        <div *ngFor="let item of careplanItems">
          <mat-checkbox [checked]="item.active" disabled="true">
            <ng-container *ngIf="item.obsDef; else questName">
              {{ item.obsDef | translateObservationNameFromObsDef }}
            </ng-container>
            <ng-template #questName>{{ item.displayName }}</ng-template>
            ({{ "observation.obsDefinition.linkedTo" | translate }} {{ item.originName }})
          </mat-checkbox>
          <button
            *ngIf="canUpdateParamFreq"
            mat-icon-button
            matTooltip="{{ 'btn.settings' | translate }}"
            [disabled]="!item.active"
            (click)="openParamFrequency(item)"
            aria-label="icon button with a settings icon"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </div>
      <p *ngIf="!careplanItems?.length" style="text-align: center">{{ i18n.noItems | translate }}</p>
      <br />

      <h3>{{ i18n.activitySection | translate }} :</h3>
      <div class="container">
        <div *ngFor="let item of activityItems">
          <mat-checkbox
            [checked]="item.active"
            disabled="true"
            matTooltip="{{ 'observation.obsDefinition.disabledFromActivity' | translate }}"
            [matTooltipDisabled]="item.active"
          >
            <ng-container *ngIf="item.obsDef; else questName">
              {{ item.obsDef | translateObservationNameFromObsDef }}
            </ng-container>
            <ng-template #questName>{{ item.displayName }}</ng-template>
            ({{ "observation.obsDefinition.linkedTo" | translate }} {{ item.originName }})
          </mat-checkbox>
          <button
            *ngIf="canUpdateParamFreq"
            mat-icon-button
            matTooltip="{{ 'btn.settings' | translate }}"
            [disabled]="!item.active"
            (click)="openParamFrequency(item)"
            aria-label="icon button with a settings icon"
          >
            <mat-icon>settings</mat-icon>
          </button>
        </div>
      </div>
      <p *ngIf="!activityItems?.length" style="text-align: center">{{ i18n.noItems | translate }}</p>
      <br />

      <ng-container *ngIf="context === 'Observation'">
        <h3>{{ "observation.obsDefinition.questionnaireObs" | translate }} :</h3>
        <div class="container">
          <div *ngFor="let item of questionnaireItems">
            <mat-checkbox
              [checked]="item.active"
              disabled="true"
              matTooltip="{{ 'observation.obsDefinition.disabledFromActivity' | translate }}"
              [matTooltipDisabled]="item.active"
            >
              {{ item.obsDef | translateObservationNameFromObsDef }}
            </mat-checkbox>
            <button
              *ngIf="canUpdateParamFreq"
              mat-icon-button
              matTooltip="{{ 'btn.settings' | translate }}"
              disabled="true"
              aria-label="icon button with a settings icon"
            >
              <mat-icon>settings</mat-icon>
            </button>
          </div>
        </div>
        <p *ngIf="!questionnaireItems?.length" style="text-align: center">
          {{ "observation.obsDefinition.noLinkedObs" | translate }}
        </p>
        <br />
      </ng-container>

      <h3>{{ i18n.standaloneSection | translate }} :</h3>
      <div class="container">
        <div *ngFor="let item of standaloneItems">
          <div [matTooltip]="(canAddStandalone ? (!item.canBeDisabled ? i18n.removeError : '') : 'common.notAuthorized') | translate">
            <mat-checkbox
              [checked]="item.active"
              [value]="item.standaloneId"
              [disabled]="
                !item.canBeDisabled || !canAddStandalone || ('dashboard/configurationPatient' | isAuthorized : 'PUT' | async) === false
              "
              (change)="onStandaloneChange($event, item)"
            >
              <ng-container *ngIf="item.obsDef; else questName">
                {{ item.obsDef | translateObservationNameFromObsDef }}
              </ng-container>
              <ng-template #questName>{{ item.displayName }}</ng-template>
            </mat-checkbox>
            <button
              *ngIf="canUpdateParamFreq"
              mat-icon-button
              matTooltip="{{ 'btn.settings' | translate }}"
              [disabled]="!item.active || (!patientParamIds.includes(item.settingsId) && !patientParamIds.includes(item.standaloneId))"
              (click)="openParamFrequency(item)"
              aria-label="icon button with a settings icon"
            >
              <mat-icon>settings</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <p *ngIf="!standaloneItems?.length" style="text-align: center">{{ i18n.noItems | translate }}</p>
    </div>
  </div>

  <div class="actionButton">
    <button mat-raised-button color="primary" type="button" *ngIf="!data?.patientId" (click)="onFinish()">
      {{ (patientRegistrationService.isLastStep ? "model.patient.finish" : "globalHelp.nextSlide") | translate }}
    </button>
  </div>
</div>
